// eslint-disable-next-line no-restricted-imports
import {on} from 'delegated-events'

on('change', '.js-waitlist-countries-select', ({currentTarget}) => {
  toggleUnsupportedWarning(currentTarget as HTMLSelectElement)
})

on('change', '.js-waitlist-parent-listing-id-select', ({currentTarget}) => {
  const selectMenu = currentTarget as HTMLSelectElement
  const firstSelection = selectMenu.selectedOptions[0]!
  const selectedParentListingID = firstSelection.value

  toggleFiscallyHostedProjectProfileInputs(selectedParentListingID)
})

on('change', '.js-sponsors-required-input-trigger', ({currentTarget}) => {
  const target = currentTarget as HTMLInputElement | HTMLSelectElement
  if (target.value === '') return

  const targetInputs = document.querySelectorAll('.js-sponsors-required-input-target')
  for (const element of targetInputs) {
    const triggerValues = element.getAttribute('data-sponsors-trigger-values')
    if (triggerValues) {
      const inputOrSelect = element as HTMLInputElement | HTMLSelectElement
      inputOrSelect.required = triggerValues.includes(target.value)
    }
  }
})

// Toggle the unsupported country warning for a given country select menu. Keeps displaying the warning as long as
// any unsupported country is chosen within country selects in the container.
function toggleUnsupportedWarning(select: HTMLSelectElement) {
  const container = select.closest<HTMLElement>('.js-waitlist-countries-container')!
  const warning = container.querySelector<HTMLElement>('.js-waitlist-country-unsupported-warning')
  if (!warning) return

  warning.hidden = isSupportedCountrySelected(select)
}

function isSupportedCountrySelected(select: HTMLSelectElement) {
  const selectedOption = select.selectedOptions[0]
  if (!(selectedOption instanceof HTMLOptionElement)) {
    // Not working with an option element so don't show the warning because it doesn't apply
    return true
  }

  const supportedCountriesStr = select.getAttribute('data-supported-countries') || ''
  const supportedCountries = supportedCountriesStr.split(',')
  return supportedCountries.includes(selectedOption.value)
}

// Toggle the fiscally hosted project profile input for organizations and users.
function toggleFiscallyHostedProjectProfileInputs(selectedParentListingID: string) {
  const inputsContainer = document.querySelector<HTMLElement>('.js-sponsors-project-profile-fiscal-host-inputs')!
  inputsContainer.hidden = selectedParentListingID === ''
}
